<div class="transaction-type" [ngClass]="SecurityTransactionType[transactionType]">
  <span>{{ transactionType | securityTransactionType | splitByCapitalLetterPipe }}</span>
</div>
